export const DEFAULT_SPARE_PART_SHIPPING_RECEIPT =
  'https://www.dac.com.uy/envios/rastreo/Codigo_Rastreo/';
